<template>
  <div class="d-flex flex-column app" :style="frame">
    <!--<div> Frame : {{ frame }} </div>-->
    <router-view />
    <Feed ref="feed" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Feed from './components/Feed.vue';
import "moment/locale/tr";

export default {
  components: { Feed },
  computed: {
    ...mapState(['maxWidth']),
    frame() {
      return {
        height: `${this.$screen.height}px`,
        maxWidth: `${this.maxWidth}px`,
        width: `${this.$screen.width}px`,
        margin: 'auto',
      };
    },
  },
  created() { },
  mounted() {
    //console.log(this.$screen);
  },
  watch: {
    '$screen.width'(current, old) {
      this.addResizeEvent('Width', current, old);
    },
    '$screen.height'(current, old) {
      this.addResizeEvent('Height', current, old);
    },
    '$screen.sm'(active) {
      this.addBreakpointEvent('SM', active);
    },
    '$screen.md'(active) {
      this.addBreakpointEvent('MD', active);
    },
    '$screen.lg'(active) {
      this.addBreakpointEvent('LG', active);
    },
    '$screen.xl'(active) {
      this.addBreakpointEvent('XL', active);
    },
    '$screen.portrait'(active) {
      this.addOrientationEvent(active);
    },
  },

  methods: {
    ...mapActions(['addEventMessage']),
    addBreakpointEvent(breakpoint, active) {
      //this.$refs.feed.add(`Breakpoint ${active ? 'entered' : 'left'}: ${breakpoint}`);
//      this.addEventMessage(`Breakpoint ${active ? 'entered' : 'left'}: ${breakpoint}`);
    },
    addResizeEvent(property, current, old) {
      //this.$refs.feed.add(`${property} changed: ${old} → ${current}`);
//      this.addEventMessage(`${property} changed: ${old} → ${current}`);
    },
    addOrientationEvent(portrait) {
      //this.$refs.feed.add(`Orientation changed: ${portrait ? 'portrait' : 'landscape'}`);
//      this.addEventMessage(`Orientation changed: ${portrait ? 'portrait' : 'landscape'}`);
    },
  }
};
</script>


<style lang="scss">
 @import "assets/scss/style";

 /*.modal-open .app {
  visibility: hidden;
 }*/
 .leaflet-popup {
  bottom: 10px !important;
 }
 .leaflet-popup-content {
  color: #FF7133;
  font-size: 12px;
  font-weight: 400;
  line-height: 16.34px !important;
}
</style>
